import * as React from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Link, useLocation } from "react-router-dom";
import {
  Box,
  Menu,
  MenuItem,
  Badge,
  IconButton,
  Typography,
} from "@mui/material";
import Logo from "../assests/apu-logo.png";
import "../App.css";
import Spinner from "./spinner";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useMsal } from "@azure/msal-react";
import Logout from "./logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  getNotifications,
  markNotificationRead,
  getPermissions,
} from "../api/serverApi";
import { Divider } from "@mui/material";

const TopNav = () => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  // --------------------------------------------------------------
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [permissionData, setPermissionData] = useState(null);

  // =====================================================================
  const [logoutModal, setLogoutModal] = useState(false);
  const [cookies, , removeCookie] = useCookies([
    "email",
    "name",
    "permissions",
    "accessToken",
  ]);
  const [isRotated, setIsRotated] = useState(false);
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const siteCreationPaths = [
    "/sitecreation",
    "/survey-managment",
    "/court-litigation",
    "/building",
    "/court-history",
  ];
  const role = cookies.permissions;
  const [userReady, setUserReady] = useState(!!cookies.name);

  useEffect(() => {
    if (cookies.name) {
      setUserReady(true);
    }
  }, [cookies.name]);

  useEffect(() => {
    if (cookies.accessToken) {
      loadNotifications();
    }
  }, [cookies.accessToken]);

  const loadNotifications = async () => {
    try {
      const data = await getNotifications(cookies.accessToken);
      setNotifications(data);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const handleNotificationClick = async (event) => {
    setAnchorEl(event.currentTarget);

    try {
      const data = await getNotifications(cookies.accessToken);
      setNotifications(data);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationItemClick = async (notification) => {
    if (!notification.is_read) {
      try {
        await markNotificationRead(notification.id, cookies.accessToken);
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === notification.id ? { ...n, is_read: true } : n,
          ),
        );
      } catch (err) {
        console.error("Error updating notification:", err);
      }
    }
    // handleClose();
  };

  if (!userReady) {
    return <Spinner />;
  }

  const linkStyle = (path, activePaths) => ({
    textDecoration: "none",
    color: activePaths.includes(location.pathname) ? "#1976d2" : "gray",
    fontWeight: activePaths.includes(location.pathname) ? "bold" : "normal",
    transition: "0.3s",
  });
  // -permission modal
  const loadPermissions = async () => {
    try {
      const response = await getPermissions(cookies.accessToken);

      console.log("response =", response);

      const users = response.data;

      const currentUser = users.find(
        (item) =>
          item.user_name?.trim().toLowerCase() ===
          cookies.name?.trim().toLowerCase(),
      );

      console.log("currentUser =", currentUser);

      setPermissionData(currentUser || null);
    } catch (err) {
      console.error("Failed to fetch permissions:", err);
    }
  };
  // --------------------------------------------------
  const handleRotation = () => {
    setIsRotated(!isRotated);
    if (!isRotated) {
      setLogoutModal(true);
    } else {
      setLogoutModal(false);
    }
  };

  function signOutClickHandler(instance) {
    setLoading(false);
    removeCookie("email", { path: "/" });
    removeCookie("name", { path: "/" });
    removeCookie("permissions", { path: "/" });
    removeCookie("accessToken", { path: "/" });

    const logoutRequest = {
      account: accounts[0],
      postLogoutRedirectUri: "/",
    };
    instance.logoutRedirect(logoutRequest);
  }

  return (
    <div className="bg-white min-h-[64px] border-b-[2px]">
      <div className="flex flex-wrap items-center justify-between">
        <img
          src={Logo}
          alt="logo"
          height={130}
          width={130}
          className="px-4 py-2 flex-shrink-0"
        />

        <div className="py-4 flex-1 min-w-0 text-lg">
          <Box
            sx={{
              display: "flex",
              gap: { xs: 1, sm: 2, md: 3 },
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            {(role === "Admin" ||
              role === "State Admin" ||
              role === "Location Admin") && (
              <Link
                to="/sitecreation"
                style={linkStyle("/sitecreation", siteCreationPaths)}
              >
                Site Creation
              </Link>
            )}
            {role === "Admin" && (
              <Link
                to="/access-manager"
                style={linkStyle("/access-manager", ["/access-manager"])}
              >
                Access Manager
              </Link>
            )}

            {(role === "Admin" ||
              role === "Spoc" ||
              role === "State Admin" ||
              role === "Location Admin") && (
              <Link to="/upload" style={linkStyle("/upload", ["/upload"])}>
                Upload
              </Link>
            )}

            {(role === "Admin" ||
              role === "State Admin" ||
              role === "Location Admin") && (
              <Link
                to="/approval"
                style={linkStyle("/approval", ["/approval"])}
              >
                Approval
              </Link>
            )}

            {(role === "Admin" ||
              role === "Spoc" ||
              role === "End User" ||
              role === "State Admin" ||
              role === "Location Admin") && (
              <Link to="/file" style={linkStyle("/file", ["/file"])}>
                Files
              </Link>
            )}

            {(role === "Admin" ||
              role === "End User" ||
              role === "Spoc" ||
              role === "State Admin" ||
              role === "Location Admin") && (
              <Link to="/report" style={linkStyle("/report", ["/report"])}>
                Reports
              </Link>
            )}
          </Box>
        </div>

        <div className="flex flex-row space-x-2 md:space-x-4 pr-2 md:pr-6 flex-shrink-0">
          {loading && <Spinner />}

          <div className="flex items-center space-x-2 py-2">
            {(role === "End User" || role === "Spoc") && (
              <>
                <IconButton color="inherit" onClick={handleNotificationClick}>
                  <Badge badgeContent={unreadCount} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    style: { maxHeight: 300, width: 350 },
                  }}
                >
                  {notifications.length === 0 ? (
                    <MenuItem disabled>No notifications</MenuItem>
                  ) : (
                    notifications.map((n, index) => (
                      <div key={n.id}>
                        <MenuItem
                          onClick={() => handleNotificationItemClick(n)}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: n.is_read ? "normal" : "bold",
                              whiteSpace: "normal",
                            }}
                          >
                            {n.message}
                          </Typography>
                        </MenuItem>
                        {index !== notifications.length - 1 && <Divider />}
                      </div>
                    ))
                  )}
                </Menu>
              </>
            )}

            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#1976d2] text-white flex items-center justify-center font-semibold text-sm md:text-base">
              {cookies.name?.charAt(0).toUpperCase()}
            </div>

            <div className="hidden sm:flex flex-col">
              <div className="text-sm md:text-base">{cookies.name}</div>
              <div className="text-xs md:text-sm text-gray-500">{role}</div>
            </div>
          </div>

          <ClickAwayListener
            onClickAway={() => {
              setLogoutModal(false);
              setIsRotated(false);
            }}
          >
            <div className="relative">
              <button>
                <div
                  className={`ml-auto transform transition-transform duration-300 ${
                    isRotated ? "rotate-180" : "rotate-0"
                  }`}
                  onClick={handleRotation}
                >
                  <span className="text-black">&#9660;</span>
                </div>
              </button>

              {logoutModal && (
                <div className="absolute right-0 top-10 bg-white shadow-lg rounded-md border z-50 min-w-[180px]">
                  {role !== "Admin" && (
                    <button
                      className="w-full text-left px-4 py-3 hover:bg-gray-100"
                      onClick={() => {
                        loadPermissions();
                        setShowPermissionModal(true);
                      }}
                    >
                      Permission
                    </button>
                  )}

                  <div className="border-t"></div>

                  <button
                    className="w-full text-left px-4 py-3 hover:bg-gray-100"
                    onClick={() => signOutClickHandler(instance)}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </ClickAwayListener>
        </div>
      </div>
      {/* {logoutModal && <Logout onClick={() => signOutClickHandler(instance)} />} */}
      {showPermissionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-6xl p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">My Permissions</h2>

              <button
                onClick={() => setShowPermissionModal(false)}
                className="text-xl"
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <strong>Name:</strong> {permissionData?.user_name}
              </div>

              <div>
                <strong>Role:</strong> {permissionData?.role_name}
              </div>
            </div>

           <div className="overflow-auto max-h-[500px]">
  <table className="w-full border-collapse border">
    <thead>
      <tr className="bg-gray-100">
        <th className="border p-3">State</th>
        <th className="border p-3">Location</th>

        {(permissionData?.role_name === "Spoc" ||
          permissionData?.role_name === "End User") && (
          <th className="border p-3">Site</th>
        )}

        <th className="border p-3">Document Categories</th>
        <th className="border p-3">Approver</th>
      </tr>
    </thead>

    <tbody>
      {permissionData?.permissions?.map((perm, index) => (
        <tr key={index}>
          <td className="border p-3 text-center">
            {perm.state_name}
          </td>

          <td className="border p-3 text-center">
            {perm.location_name}
          </td>

          {(permissionData?.role_name === "Spoc" ||
            permissionData?.role_name === "End User") && (
            <td className="border p-3 text-center">
              {perm.site_name}
            </td>
          )}

          <td className="border p-3 text-center">
            {Array.isArray(perm.category_name)
              ? perm.category_name.join(", ")
              : perm.category_name}
          </td>

          <td className="border p-3 text-center">
            {perm.approver?.length ? (
              perm.approver.map((name, idx) => (
                <div key={idx}>
                  {name}
                  {idx !== perm.approver.length - 1 && ","}
                </div>
              ))
            ) : (
              "-"
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopNav;
